export default class LightstickCounter{
    constructor(scene, x = 35, y = 50) {
        let total = JSON.parse(localStorage.getItem('noL'));
        let totalToShow = 0;
        if(total) {
            totalToShow = total.length;
        }   
        scene.add.image(x, y, `lightstick`, 0).setScale(2).setOrigin(1, 0).setScrollFactor(0).setAngle(30);
        scene.add.bitmapText(x+10, y+10, 'pixelfont', `${totalToShow}`.toUpperCase(), 10, 1).setTint(0xFFFFFF).setDepth(1).setOrigin(1, 0).setScrollFactor(0).setScale(1.5)

    }
}